import { Action, createReducer, on } from '@ngrx/store';
import { fromProductSubTypesAction } from '../actions';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IStaticDataResponse } from '../models/static-data.model';

export const productSubTypesByTypeFeatureKey = 'productSubTypesByType';

export interface ProductSubTypesByTypeState {
  productSubTypesByTypeResponse: IStaticDataResponse[];
  productSubTypesByTypeFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: ProductSubTypesByTypeState = {
  productSubTypesByTypeFailure: undefined,
  productSubTypesByTypeResponse: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromProductSubTypesAction.loadProductSubTypesByType, (state, action) => ({
    ...state,
    loaded: true
  })),

  on(fromProductSubTypesAction.loadProductSubTypesByTypeSuccess, (state, action) => ({
    ...state,
    productSubTypesByTypeResponse: action.response
  })),

  on(fromProductSubTypesAction.loadProductSubTypesByTypeFailure, (state, action) => ({
    ...state,
    productSubTypesByTypeFailure: action.error
  }))
);

export const getProductSubTypesByTypeResponse = (state: ProductSubTypesByTypeState) => state.productSubTypesByTypeResponse;
export const getProductSubTypesByTypeFailure = (state: ProductSubTypesByTypeState) => state.productSubTypesByTypeFailure;
export const getProductSubTypesByTypeIsLoaded = (state: ProductSubTypesByTypeState) => state.loaded;
